import { createComponent } from '@carvana/merch-components';
import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & {
  white?: boolean;
};

const Locked = createComponent<OwnProps>('svg', props => ({
  className: props.white ? 'stroke-white' : 'stroke-blue-6'
}));

const LockedIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <Locked
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    ref={ref}
    {...props}
  >
    <rect x="3.5" y="8.25024" width="9" height="7" />
    <path d="M5.5 4.75024C5.5 3.36953 6.61929 2.25024 8 2.25024C9.38071 2.25024 10.5 3.36953 10.5 4.75024V8.25024H5.5V4.75024Z" />
    <path d="M8 10.7502V12.7502" strokeLinecap="round" />
  </Locked>
));

export default LockedIcon;
